if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.ensureSingleSizeSelected(this.getVariantSelects());
      }

      getVariantSelects() {
        const sectionId = this.dataset.sectionId;
        return sectionId
          ? document.querySelector(`variant-selects#variant-selects-${sectionId}`)
          : document.querySelector('variant-selects');
      }

      applySelectedVariantId(variantSelects = this.getVariantSelects()) {
        if (!variantSelects || !this.variantIdInput) return false;

        const selectedVariantScript = variantSelects.querySelector('[data-selected-variant]');
        if (!selectedVariantScript?.textContent) return false;

        try {
          const variant = JSON.parse(selectedVariantScript.textContent);
          if (!variant?.id) return false;

          this.variantIdInput.value = variant.id;
          this.variantIdInput.disabled = false;

          const stickyButton = document.querySelector('.sticky-atc__button');
          if (stickyButton) stickyButton.dataset.variantId = variant.id;

          return true;
        } catch (e) {
          return false;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.validateVariantSelections()) return;

        // Ensure single-size products always submit a real variant id
        const variantSelects = this.getVariantSelects();
        if (variantSelects?.querySelector('[data-single-size="true"]')) {
          this.ensureSingleSizeSelected(variantSelects);
          if (!this.variantIdInput?.value) {
            this.applySelectedVariantId(variantSelects);
          }
        }

        if (!this.variantIdInput?.value) {
          this.handleErrorMessage(
            window.variantStrings?.sizeSelectionError || 'Cannot find variant',
            'sizeSelectionError'
          );
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        this.originalButtonText = this.submitButtonText.textContent;
        this.submitButtonText.textContent = window.variantStrings?.adding || 'ADDING';

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              let responseError = response.description;
              let errorType = false;
              const isSingleSize = !!document.querySelector('variant-selects [data-single-size="true"]');
              if (response.status == '422' && response.description == 'Cannot find variant') {
                if (!isSingleSize) {
                  responseError = window.variantStrings.sizeSelectionError;
                  errorType = 'sizeSelectionError';
                }
              }
              this.handleErrorMessage(responseError, errorType);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (this.originalButtonText) {
              this.submitButtonText.textContent = this.originalButtonText;
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false, errorType = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        const variantOptionWrapper = document.querySelector('variant-selects');
        const sizeVariantOption = variantOptionWrapper?.querySelector('.product-size__container');
        const lengthVariantOption = variantOptionWrapper?.querySelector('.product-length__container');
        const isSingleSize = !!variantOptionWrapper?.querySelector('[data-single-size="true"]');
        let errorTypes = Array.isArray(errorType) ? [...errorType] : errorType ? [errorType] : [];

        // Single size is hidden/auto-selected — never treat as a size selection error
        if (isSingleSize) {
          errorTypes = errorTypes.filter((type) => type !== 'sizeSelectionError');
          if (!errorTypes.length && errorMessage === window.variantStrings?.sizeSelectionError) {
            errorMessage = false;
            this.errorMessageWrapper.toggleAttribute('hidden', true);
          }
        }

        sizeVariantOption?.classList.toggle('error', errorTypes.includes('sizeSelectionError'));
        lengthVariantOption?.classList.toggle('error', errorTypes.includes('lengthSelectionError'));

        if (errorTypes.includes('sizeSelectionError') || errorTypes.includes('lengthSelectionError')) {
          variantOptionWrapper?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      ensureSingleSizeSelected(variantSelects) {
        if (!variantSelects) return;

        const singleSizeFieldset = variantSelects.querySelector('[data-single-size="true"]');
        if (!singleSizeFieldset) return;

        const sizeInput =
          singleSizeFieldset.querySelector('input[type="radio"]:not(:disabled)') ||
          singleSizeFieldset.querySelector('input[type="radio"]');
        if (!sizeInput) return;

        sizeInput.checked = true;
        this.applySelectedVariantId(variantSelects);
      }

      validateVariantSelections() {
        const sectionId = this.dataset.sectionId;
        const variantSelects = sectionId
          ? document.querySelector(`variant-selects#variant-selects-${sectionId}`)
          : document.querySelector('variant-selects');

        if (!variantSelects) return true;

        this.ensureSingleSizeSelected(variantSelects);

        const optionFieldsets = variantSelects.querySelectorAll('fieldset.product-form__input--pill');
        if (!optionFieldsets.length) return true;

        const missingErrorTypes = [];

        optionFieldsets.forEach((fieldset) => {
          // Single size is auto-selected and hidden — never block ATC for it
          if (fieldset.dataset.singleSize === 'true') return;

          const selectableInputs = fieldset.querySelectorAll('input[type="radio"]:not(:disabled)');
          if (!selectableInputs.length) return;
          if (fieldset.querySelector('input[type="radio"]:checked')) return;

          if (fieldset.classList.contains('product-length__container')) {
            missingErrorTypes.push('lengthSelectionError');
          } else {
            missingErrorTypes.push('sizeSelectionError');
          }
        });

        if (missingErrorTypes.length) {
          const hasSizeError = missingErrorTypes.includes('sizeSelectionError');
          const hasLengthError = missingErrorTypes.includes('lengthSelectionError');
          let errorMessage = window.variantStrings?.sizeSelectionError;

          if (hasSizeError && hasLengthError) {
            errorMessage = [window.variantStrings?.sizeSelectionError, window.variantStrings?.lengthSelectionError]
              .filter(Boolean)
              .join(' ');
          } else if (hasLengthError) {
            errorMessage = window.variantStrings?.lengthSelectionError;
          }

          this.handleErrorMessage(errorMessage, missingErrorTypes);
          return false;
        }

        return true;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
